import { useState, useCallback } from 'react';
import { bcService } from '../services/bcService';

export const useBCActions = (operationId: string) => {
  const [loading, setLoading] = useState(false);

  const handleLancerConsultation = useCallback(async (rang: number, operation: any) => {
    setLoading(true);
    try {
      await bcService.lancerConsultationRang(operationId, rang, {
        nom: operation.formulaire?.nomOperation,
        besoin: operation.formulaire?.besoin,
        adresse: operation.formulaire?.adresse,
        code_postal: operation.formulaire?.codePostal,
        ville: operation.formulaire?.ville,
        articles: operation.selectedProducts || operation.formulaire?.sections
      });

      alert(`Consultation lancée avec le prestataire de rang ${rang}`);
      window.location.reload();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du lancement de la consultation');
    } finally {
      setLoading(false);
    }
  }, [operationId]);

  const handleAccepterCommande = useCallback(async () => {
    await fetch(`${process.env.REACT_APP_API_URL}bdc/commande/${operationId}/accept`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        // Add the data you want to send
      }),
    });
    alert('Commande acceptée avec succès');
    window.location.reload();
  }, [operationId]);

  const handleRefuserCommande = useCallback(async (rang: number, reason?: string) => {
    setLoading(true);
    try {
      await bcService.refuserCommande(operationId, rang, reason);

      if (rang < 3) {
        alert(`Commande refusée. Elle a été transmise au prestataire de rang ${rang + 1}`);
      } else {
        alert('Commande refusée par tous les prestataires. Procédure terminée.');
      }

      window.location.reload();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du refus de la commande');
    } finally {
      setLoading(false);
    }
  }, [operationId]);

  return {
    handleLancerConsultation,
    handleAccepterCommande,
    handleRefuserCommande,
    loading
  };
};